"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var useIntersect_1 = tslib_1.__importDefault(require("../../hooks/useIntersect"));

var PlaceholderImageWrapper_1 = tslib_1.__importDefault(require("../PlaceholderImageWrapper"));

var styles = tslib_1.__importStar(require("./ResponsiveImage.style"));

var PlaceholderImage_1 = tslib_1.__importDefault(require("../PlaceholderImage"));

function ResponsiveImage(_ref) {
  var className = _ref.className,
      src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      onClick = _ref.onClick,
      onLoadComplete = _ref.onLoadComplete,
      placeholderSrc = _ref.placeholderSrc,
      _ref$intersectOptions = _ref.intersectOptions,
      intersectOptions = _ref$intersectOptions === void 0 ? {} : _ref$intersectOptions,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? 'browser' : _ref$lazy;
  var isLoadingEnabled = ('loading' in HTMLImageElement.prototype);

  var _react_1$useState = react_1.useState(!isLoadingEnabled || lazy === 'intersect' ? '' : src),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      imgSrc = _react_1$useState2[0],
      setImage = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      isLoaded = _react_1$useState4[0],
      setIsLoaded = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(false),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      hasError = _react_1$useState6[0],
      setHasError = _react_1$useState6[1];

  var originImage = react_1.useRef(null);
  var setIntersectionRef = useIntersect_1.default(function () {
    setImage(src);
  }, Object.assign({
    root: null,
    threshold: 0,
    rootMargin: "".concat(window.innerHeight * 0.6, "px ").concat(window.innerWidth * 0.6, "px")
  }, intersectOptions));
  var handleImageLoad = react_1.useCallback(function () {
    if (originImage.current === null) {
      return;
    }

    if (onLoadComplete) {
      onLoadComplete(originImage.current);
    }

    setIsLoaded(true);
  }, [onLoadComplete]);
  var handleImageError = react_1.useCallback(function () {
    if (originImage.current === null) {
      return;
    }

    setHasError(true);
  }, []);
  react_1.useEffect(function () {
    if (imgSrc === '' || // intersect 되기 전
    originImage.current === null || originImage.current.src !== '' // 이미 로드 시작되었을 때는 중지
    ) {
      return;
    }

    originImage.current.onload = handleImageLoad;
    originImage.current.onerror = handleImageError;
    originImage.current.src = imgSrc;
  }, [handleImageLoad, handleImageError, imgSrc]);
  react_1.useEffect(function () {
    setImage(imgSrc);
  }, [imgSrc]);
  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.root,
    ref: setIntersectionRef,
    onClick: onClick
  }, {
    children: [jsx_runtime_1.jsx("img", {
      ref: originImage,
      css: styles.container,
      alt: alt,
      loading: lazy === 'browser' ? 'lazy' : 'eager'
    }, void 0), jsx_runtime_1.jsx(PlaceholderImageWrapper_1.default, Object.assign({
      isLoaded: isLoaded
    }, {
      children: jsx_runtime_1.jsx(PlaceholderImage_1.default, {
        src: placeholderSrc,
        hasError: hasError
      }, void 0)
    }), void 0)]
  }), void 0);
}

exports.default = react_1.memo(ResponsiveImage);